import { jsxs as g, jsx as n } from "react/jsx-runtime";
import { c as r } from "../../../index-Cu0xwYjD.js";
import { capitalizeFirstLetter as m } from "../../../utils/helpers.js";
const v = "ids-validation-message-v501", l = "ids-validation-message--prefix-v501", f = "ids-validation-message--message-v501", x = "ids-validation-message--danger-v501", p = "ids-validation-message--warning-v501", h = "ids-validation-message--success-v501", u = "ids-validation-message--info-v501", s = {
  validationMessage: v,
  prefix: l,
  message: f,
  "prefix--hidden": "ids-validation-message--prefix--hidden-v501",
  danger: x,
  warning: p,
  success: h,
  info: u
}, N = ({
  prefix: e,
  status: i = "danger"
}) => e || `${i === "danger" ? "Error" : m(i)}: `, j = ({
  as: e = "div",
  children: i,
  className: d,
  prefix: o,
  status: a = "danger",
  visiblePrefix: t,
  ...c
}) => /* @__PURE__ */ g(
  e,
  {
    ...c,
    className: r(
      d,
      s.validationMessage,
      s[a],
      "iress-u-text",
      `iress--${a}`
    ),
    children: [
      /* @__PURE__ */ n(
        "div",
        {
          className: r(s.prefix, {
            [s["prefix--hidden"]]: !t
          }),
          children: /* @__PURE__ */ n(N, { prefix: o, status: a })
        }
      ),
      /* @__PURE__ */ n("div", { className: s.message, children: i })
    ]
  }
);
export {
  j as ValidationBase
};
